import type { LeadRecord } from '../../domain/lead'

/**
 * Données de démonstration explicitement fictives. Elles n'emploient que les
 * statuts possédant une correspondance legacy prouvée.
 */
export const leadsFixtures: LeadRecord[] = [
  {
    id: 'lead-0000-4000-8000-000000000001',
    number: 'LEAD-2026-014',
    status: 'NEW',
    version: 1,
    contact: {
      displayName: 'Marie Tremblay',
      phone: '450-555-0142',
      email: 'marie.tremblay@exemple.test',
      address: { line1: '1450, Rue des Pins', city: 'Saint-Jérôme', postalCode: 'J7Z 0C6' },
    },
    serviceType: 'Déneigement résidentiel',
    message: 'Entrée double, demande un passage avant 6 h.',
    origin: 'Formulaire du site',
    createdAt: '2026-08-02T13:00:00Z',
    updatedAt: '2026-08-02T13:00:00Z',
  },
  {
    id: 'lead-0000-4000-8000-000000000002',
    number: 'LEAD-2026-015',
    status: 'CONTACTED',
    version: 1,
    contact: {
      displayName: 'Luc Bergeron',
      phone: '514-555-0188',
      address: { line1: '82, Avenue Principale', city: 'Blainville', postalCode: 'J7C 2K9' },
    },
    serviceType: 'Déneigement commercial',
    origin: 'Appel entrant',
    followUpAt: '2026-08-12T14:00:00Z',
    followUpNote: 'Rappeler après sa visite du stationnement.',
    createdAt: '2026-08-03T09:15:00Z',
    updatedAt: '2026-08-06T16:40:00Z',
  },
  {
    id: 'lead-0000-4000-8000-000000000003',
    number: 'LEAD-2026-016',
    status: 'QUOTE_SENT',
    version: 1,
    contact: {
      displayName: 'Sophie Nadeau',
      email: 'sophie.nadeau@exemple.test',
      address: { line1: '9, Chemin du Lac', city: 'Sainte-Adèle', postalCode: 'J8B 1A2' },
    },
    serviceType: 'Déneigement résidentiel',
    origin: 'Référence client',
    createdAt: '2026-07-28T11:00:00Z',
    updatedAt: '2026-08-07T10:05:00Z',
  },
  {
    id: 'lead-0000-4000-8000-000000000004',
    number: 'LEAD-2026-017',
    status: 'WON',
    version: 1,
    contact: {
      displayName: 'Groupe Ferland',
      phone: '450-555-0117',
      email: 'contact@ferland.exemple.test',
      address: { line1: '300, Boulevard Industriel', city: 'Mirabel', postalCode: 'J7J 1V1' },
    },
    serviceType: 'Déneigement commercial',
    origin: 'Salon commercial',
    createdAt: '2026-07-20T08:00:00Z',
    updatedAt: '2026-08-05T15:20:00Z',
  },
  {
    id: 'lead-0000-4000-8000-000000000005',
    number: 'LEAD-2026-018',
    status: 'LOST',
    version: 1,
    lostReason: 'NO_RESPONSE',
    contact: { displayName: 'Contact sans coordonnées' },
    serviceType: 'Déneigement résidentiel',
    origin: 'Formulaire du site',
    createdAt: '2026-07-15T18:30:00Z',
    updatedAt: '2026-07-30T09:00:00Z',
  },
]
